var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPowerPoint = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "evenodd",
  d: "M21 2v19h18v-.028c-.007-5.034-1.906-9.859-5.28-13.416C30.345 4 25.772 2.001 21.003 2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "evenodd",
  d: "M21 21V2c-4.774 0-9.352 2.001-12.728 5.564S3 15.96 3 20.997h18z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  fillRule: "evenodd",
  d: "M3 21h36c0 4.509-1.896 8.833-5.272 12.02C30.352 36.21 25.774 38 21 38s-9.352-1.791-12.728-4.98C4.896 29.834 3 25.51 3 21",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7865D",
  fillRule: "evenodd",
  d: "M6.236 19.441h16.342V2h.078v17.441H39v.08H6.236z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  fillRule: "evenodd",
  d: "M2.53 29.794h16.192a1.5 1.5 0 0 0 1.082-.48 1.7 1.7 0 0 0 .451-1.156V10.86a1.7 1.7 0 0 0-.451-1.153 1.5 1.5 0 0 0-1.082-.48H2.53a1.5 1.5 0 0 0-1.081.48c-.287.306-.449.72-.45 1.153v17.284c-.001.216.038.43.114.629.076.2.189.381.331.534s.311.276.497.36c.187.083.386.126.589.127",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  fillRule: "evenodd",
  d: "M18.722 29.794H2.53a1.5 1.5 0 0 1-.589-.128 1.5 1.5 0 0 1-.497-.359 1.7 1.7 0 0 1-.331-.534A1.7 1.7 0 0 1 1 28.144V10.86c.001-.432.163-.847.45-1.153a1.5 1.5 0 0 1 1.08-.48h.1a1.47 1.47 0 0 0-1.067.474 1.68 1.68 0 0 0-.445 1.14v17.191c.002.428.161.837.444 1.14a1.47 1.47 0 0 0 1.068.473h15.998c.4 0 .785-.17 1.069-.473s.444-.712.445-1.14V10.84a1.68 1.68 0 0 0-.445-1.14 1.47 1.47 0 0 0-1.07-.473h.095a1.5 1.5 0 0 1 1.081.48c.288.306.45.72.452 1.153v17.284c.001.216-.038.43-.114.63s-.19.381-.332.534a1.5 1.5 0 0 1-.498.359 1.5 1.5 0 0 1-.59.127Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  fillRule: "evenodd",
  d: "M9.132 15.964h1.995a1.5 1.5 0 0 1 1.082.48c.287.307.448.723.45 1.156v.14a1.84 1.84 0 0 1-.484 1.244c-.31.33-.728.517-1.166.518H9.13v-3.538h.003Zm-2.019-1.66h4.64a2.85 2.85 0 0 1 2.066.919 3.24 3.24 0 0 1 .858 2.205v.272a3.5 3.5 0 0 1-.925 2.374c-.59.63-1.39.986-2.224.99H9.11v3.659H7.113z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 40.072,
  x2: 21.698,
  y1: 30.913,
  y2: 25.558,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD0A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB7653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 21.718,
  x2: 3.34,
  y1: 28.51,
  y2: 23.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E17853"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AF5E3F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 38.477,
  x2: 10.49,
  y1: 48.595,
  y2: 30.359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F96A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9B301A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 20.709,
  x2: 1.02,
  y1: 36.139,
  y2: 30.462,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B14024"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#722919"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0.776,
  x2: 21.159,
  y1: 32.94,
  y2: 32.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B23F24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#8E301A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C2011"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 7.246,
  x2: 15.252,
  y1: 32.952,
  y2: 32.952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CFCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEFEFE"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPowerPoint);
export default ForwardRef;